export default "/images/12.png?39dd9159eb1cdcd507d8f5f8b99ea466";